import { Divider, Modal, Button,  } from "antd"
import { useEffect, useState } from "react"
import { connect } from "react-redux"

import { withTranslation } from "react-i18next"

import HelpDeskForm from './form';
import List from "./list"

const HelpDeskModal = (props) => {
  const [currentView, setCurrentView] = useState('list')

  useEffect(() => {
    fetchData()    
  }, []) // eslint-disable-line

  const fetchData = async () => {
    try {
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <Modal
      visible={props.visible}
      onOk={props.onOk}
      onCancel={props.onOk}
      footer={null}
      maskClosable={false}
    >
      <div style={{ fontSize: 16 }}>Support</div>
      <Divider />

      {
        currentView === 'list' && (
          <div style={{ display: 'flex', justifyContent: 'flex-end'}}>
            <Button onClick={() => setCurrentView('form')} type="link" style={{ margin: 0, padding: 0, textDecoration: 'underline'}}>Un problème avec une commande ?</Button>
          </div>
        )
      }

      {
        currentView === 'list' ? (
          <List />
        ) : (
          <HelpDeskForm 
            handleOnCancelFormView={() => setCurrentView('list')}
          />
        )
      }
    </Modal>
  )
}

const stateToProps = state => ({
  auth: state.auth
})

export default connect(stateToProps)(withTranslation()(HelpDeskModal))